import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faFacebook, faGoogle, faInstagram, faLinkedin, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { environment } from 'src/environments/environment';
import { CmsFooterContactsProperties, CmsFooterSitemapProperties, CmsFooterSocialProperties } from '../Models/CmsFooterContactsProperties';
import { CmsLoginDealsProperties } from '../Models/CmsLoginDealsProperties';
import { CmsLoginHeaderProperties, CmsLogoProperties, GetAllCmsLoginProperties } from '../Models/CmsLoginHeaderProperties';
import { CmsLoginMainContentProperties, OTPLogin } from '../Models/CmsLoginMainContentProperties';
import { LoginSliderImagesProperties } from '../Models/LoginSliderImagesProperties';
import { LoginUserProperties } from '../Models/UsersProperties';
import { AuthService } from '../Services/auth.service';
import { CMSService } from '../Services/cms.service';
import { UsersService } from '../Services/users.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  logoPathCompany:string="";
  companyName=environment.companyName;
  otp=new OTPLogin();
  contentHome: boolean = false;
  loginSliderImageData: LoginSliderImagesProperties[] = [];
  allData$: GetAllCmsLoginProperties;
  navigation: CmsLoginHeaderProperties[] = [];
  loginLanding: CmsLoginMainContentProperties[] = [];
  deals: CmsLoginDealsProperties[] = [];
  footerContacts: CmsFooterContactsProperties[] = [];
  footerSitemap: CmsFooterSitemapProperties[] = [];
  footerSocial: CmsFooterSocialProperties[] = [];
  homeLogo = new CmsLogoProperties();
  faFacebook=faFacebook;
  faInstagram=faInstagram;
  faTwitter=faTwitter;
  faLinkedin=faLinkedin;
  faGoogle=faGoogle;
  spinner: boolean = false;
  logo = '';
  valid = true;
  loginCred = new LoginUserProperties();
  otpSection:boolean=false;
  loginSection:boolean=true;
  changenewpassSection:boolean=false;
  dataotpform:boolean=false;
  isLoadPanelVisible: boolean = false;
  objects: any[] = [];
  visible: boolean = false;
  mobScreen: number = 0;
  isMobile: boolean = false;
  position: string = 'top'; 
  constructor(private authservice: AuthService, public cmsService: CMSService, private router: Router, private userService: UsersService
  ) {
    
  }
  ngOnInit() {
    
    this.isLoadPanelVisible = true;
    this.GetLoginSliderImges();
    //localStorage.clear();
    this.getAllData();
    let userid = Number(localStorage.getItem("UserId")); 
    let agencyId = localStorage.getItem("AgencyId");
    if (userid > 0 && userid != null && userid != undefined && agencyId != null && agencyId != undefined && agencyId != "") {
      let timelogin : string | null;
       timelogin = String(localStorage.getItem("TimeOfLogin"));
       let datetimefuture = new Date(JSON.parse(timelogin));

      let datenow = new Date();
      //////////console.log ("datenow", datenow);
      if (datenow < datetimefuture) {

        this.router.navigateByUrl('/flightSearch');
      }
      else {

        window.localStorage.setItem('logout-event', Math.random().toString());
        this.authservice.logOut();
        this.router.navigateByUrl('/home');
      }
    }
    else {
    }
  }

  GetLoginSliderImges() {
    this.cmsService.getLoginSliderImges().subscribe((data) => {
      if (data != null) {
        this.isLoadPanelVisible = false;
        this.loginSliderImageData = data;  

        this.objects = this.loginSliderImageData.map(item => ({
          img: item.logo 
        }));
      }
    });
  }
  getAllData() {
    try {
      this.cmsService.getFooterData().subscribe((data) => {
        this.footerSocial = data.footerSocial;
      });
    } catch (e) { }
  }
  toCapitalLettersForAgency(str, e) {
    ////////console.log (str);
    if (str == undefined && str == null && str == "") {
      return
    }
    var event = e.target.id;

    var agencyid = document.getElementById("agencyid") as HTMLInputElement;
    var newagencyid = agencyid.id;


    if (event == newagencyid) {
      var capitalizeticketpnr = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toUpperCase();
        }

      );
      this.loginCred.agencyId = capitalizeticketpnr;
    }

  }

  //public verifyOTP=(dataform:any)=> {
  //  this.dataotpform = true;
  //  if (dataform.Invalid) {
  //    return;
  //  }
  //  try {
  //    this.loginCred.otp=this.otp.digit1+this.otp.digit2+this.otp.digit3+this.otp.digit4+this.otp.digit5+this.otp.digit6;
  //    this.cmsService.emailOTPVerify(this.loginCred).subscribe((data) => {
  //      ////////////console.log ("Verify Response: " + data);
  //      if (data == true) {
  //        this.authservice.login();
  //        localStorage.setItem("ParentHierarchy", this.loginCred.parentHierarchy);
  //        localStorage.setItem("UserId", this.loginCred.userId.toString());
  //        localStorage.setItem("AgencyId", this.loginCred.agencyId);
  //        localStorage.setItem("Phone", this.loginCred.mobile);
  //        localStorage.setItem("fullName", this.loginCred.fullName);
  //        localStorage.setItem("ParentAgency", this.loginCred.parentAgency);
  //        localStorage.setItem("UserActive", String(this.loginCred.userActive))
  //        localStorage.setItem("ImmediateParent", this.loginCred.immediateParent);
  //        localStorage.setItem("BackSystemCompanyId", this.loginCred.backSystemCompanyId.toString());
  //        localStorage.setItem("BackSystemCompanyCustomer", this.loginCred.backSystemCompanyCustomer);
  //        // var checkactive = localStorage.getItem("UserActive");
  //        this.otpSection=false;
  //        this.changenewpassSection=false;
  //        this.loginSection=false;
  //        this.router.navigateByUrl('/flightSearch');
  //      }
  //      else {
  //        document.getElementById("response-screenOTP")!.innerHTML = "Invalid OTP, Please try again..!"
  //        setTimeout(() => {
  //          document.getElementById("response-screenOTP")!.innerHTML = "";
  //        }, 3000);
  //      }
  //    });
  //  } catch (e) { }
  //}

  public verifyOTP = (dataform: any) => {
    this.dataotpform = true;
    if (dataform.Invalid) {
      return;
    }
    try {
      this.loginCred.otp = this.otp.digit1+this.otp.digit2+this.otp.digit3+this.otp.digit4+this.otp.digit5+this.otp.digit6;
      this.cmsService.emailOTPVerify(this.loginCred).subscribe((data) => {
        if (data == true) {
          // Store basic user info
          localStorage.setItem("ParentHierarchy", this.loginCred.parentHierarchy);
          localStorage.setItem("UserId", this.loginCred.userId.toString());
          localStorage.setItem("AgencyId", this.loginCred.agencyId);
          localStorage.setItem("Phone", this.loginCred.mobile);
          localStorage.setItem("Email", this.loginCred.email);
          localStorage.setItem("fullName", this.loginCred.fullName);
          localStorage.setItem("ParentAgency", this.loginCred.parentAgency);
          localStorage.setItem("UserActive", String(this.loginCred.userActive));
          localStorage.setItem("ImmediateParent", this.loginCred.immediateParent);
          localStorage.setItem("BackSystemCompanyId", this.loginCred.backSystemCompanyId.toString());
          localStorage.setItem("BackSystemCompanyCustomer", this.loginCred.backSystemCompanyCustomer);
          localStorage.setItem("AgencyCurrency", this.loginCred.agencyCurrency);

          // Fetch and store navigation menu permissions
          this.fetchUserPermissions(this.loginCred.agencyId, this.loginCred.userId.toString());

          this.authservice.login();
          this.otpSection = false;
          this.changenewpassSection = false;
          this.loginSection = false;
          this.router.navigateByUrl('/flightSearch');
        } else {
          document.getElementById("response-screenOTP")!.innerHTML = "Invalid OTP, Please try again..!"
          setTimeout(() => {
            document.getElementById("response-screenOTP")!.innerHTML = "";
          }, 3000);
        }
      });
    } catch (e) { }
  }

  private fetchUserPermissions(agencyId: string, userId: string) {
    this.userService.GetUsersNavMenu(agencyId, userId).subscribe({
      next: (data) => {
        this.authservice.setNavMenu(data);

        // Store insurance rights separately if needed
        localStorage.setItem("InsuranceRights", JSON.stringify({
          "issue": data.insuranceIssuanceRight,
          "view": data.insuranceBookedViewRight,
          "cancel": data.insuranceCancelRight
        }));
      },
      error: (error) => {
        console.error('Error fetching user permissions', error);
      }
    });
  }

  userLogin() {
    try {
      this.spinner = true;
      this.cmsService.userLoginEmail(this.loginCred).subscribe((data) => {
        if (data.isAuthorized == true) {
          this.loginCred = data;
          this.spinner = false;
          if (data.userActive == true) {
            this.loginCred.otp = "";
            this.otpSection=true;
            this.changenewpassSection=false;
            this.loginSection=false;
            this.loginCred.password = "";
          }
          else {
            this.loginCred.otp = "";
            this.otpSection=false;
            this.changenewpassSection=true;
            this.loginSection=false;
            this.loginCred.password = "";
          }
        }
        else {
          this.spinner = false;
        }
      });
    }
    catch (e) {
    }
  }

  showDialog() {
    this.visible = true;
  }
  
  validatePassword() {
    var st = document.getElementById('password') as HTMLInputElement;
    var stu = document.getElementById('confirm_password') as HTMLInputElement;
    if (st.value != stu.value) {
      document.getElementById('message')!.style.color = 'red';
      document.getElementById('message')!.innerHTML = 'Password is not Matched';
      this.valid = false;
    } else {
      this.valid = true;
      document.getElementById('message')!.innerHTML = '';
    }
    return this.valid;
  }
  UpdateNewUserPassword() {
    if (this.validatePassword() == false) {
      return;
    };
    try {
      var checkv = localStorage.getItem("UserId");
      this.cmsService.UpdateNewUserPassword(this.loginCred).subscribe((data) => {
        if (data == true) {
          this.router.navigateByUrl('/flightSearch');
        }
      });
    }
    catch (e) {
    }

  }

  handleKeyDown(event: KeyboardEvent, nextField: number) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
      const digit = event.key;
      if (digit.match(/[0-9]/)) {
 
        this.otp['digit'+nextField] = digit;
   
          if(nextField == 6){
            const nextInput = document.getElementById("digit"+(nextField)) as HTMLInputElement;
            nextInput.focus();
          }
          else{
            const nextInput = document.getElementById("digit"+(nextField+1)) as HTMLInputElement;
            nextInput.focus();
          }
      }
    }
  }

  responsiveOptions: any[] = [];
  responsiveOptions2: any[] = [
    {
      breakpoint: '767px',
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: '991px',
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: '1199px',
      numVisible: 2,
      numScroll: 1,
    },
  ];
  playInterval = 4000;
}
